import { gql } from '@apollo/client'

export const AUTO_LOGIN_MUTATION = gql`
  mutation($input: AutoLoginInput!) {
    autoLogin(input: $input) {
      event_id
      token
    }
  }
`